import { useState } from "react";
import { Link } from "react-router-dom";
import api from "../lib/api";

export default function ForgotPassword() {
  const [email, setEmail] = useState("");
  const [sent, setSent] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    try { await api.post("/auth/forgot-password", { email }); } catch {}
    setSent(true);
  };

  return (
    <div className="min-h-screen flex items-center justify-center p-6" style={{ background: "var(--sand)" }}>
      <div className="w-full max-w-md card-warm p-8">
        <h1 className="font-serif-display text-3xl font-semibold" style={{ color: "var(--pine)" }}>Mot de passe oublié</h1>
        {sent ? (
          <p className="mt-4 text-[var(--muted-text)]" data-testid="forgot-sent">
            Si cet email est enregistré, un lien de réinitialisation vous a été envoyé.
          </p>
        ) : (
          <form onSubmit={submit} className="mt-6 space-y-4">
            <input required type="email" placeholder="Email" className="input-field" value={email}
              onChange={e => setEmail(e.target.value)} data-testid="forgot-email" />
            <button className="btn-primary w-full justify-center" data-testid="forgot-submit">Recevoir le lien</button>
          </form>
        )}
        <div className="mt-4"><Link to="/login" className="text-sm text-[var(--forest)] hover:underline">← Retour à la connexion</Link></div>
      </div>
    </div>
  );
}
